














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FileService, { FileViewModel } from '../../api/file';
import global from '../../utils/global';
import OSS from 'ali-oss';
import AliService, { StsViewModel } from '../../api/ali';
import { Message } from 'element-ui';
import FavoriteButton from '../Favorite/FavoriteButton.vue';

@Component({
  components: {
    FavoriteButton,
  },
})
export default class FilePreview extends Vue {

  @Prop() private data!: FileViewModel;
  private imgUrl: string = global.BACKGROUND_URL + '/resource/thumb/';
  private previewUrls: string[] = [];
  private stsService: AliService = new AliService();
  private stsData!: StsViewModel;
  private client!: OSS;
  private service: FileService = new FileService();

  @Watch('data')
  private onDataChanged(val: FileViewModel, oldVal: FileViewModel) {
    // console.log(this.client);
    // console.log(val.aliasName);
    this.loadPreviewUrls();
  }

  private mounted() {
    // this.stsService.GetSTS().then((val: any) => {
    //   this.stsData = val;
    //   this.client = new OSS({
    //     accessKeyId: this.stsData.accessKeyId,
    //     accessKeySecret: this.stsData.accessKeySecret,
    //     stsToken: this.stsData.securityToken,
    //     region: this.stsData.region,
    //     bucket: this.stsData.bucket,
    //   });
    //   this.loadPreviewUrls();
    // });
    this.loadPreviewUrls();
  }

  private loadPreviewUrls() {
    this.previewUrls = [];
    // if (this.data.fileType === 0) {
    //   // const url = this.client.signatureUrl(val.serverFileName);
    //   this.previewUrls.push(this.imgUrl + this.data.thumb);
    // } else if (this.data.fileType === 2) {
    //   for (let index = 1; index <= this.data.mediaLength!; index++) {
    //     this.previewUrls.push(this.client.signatureUrl(`preview/${this.data.serverFileName}/${index}.jpg`));
    //   }
    // }
    this.service.signaturePreviewUrl(this.data.id!).then((response: any) => {
      this.previewUrls = response;
    });
  }

  private btnDownload_OnClick() {
    const val = this.data!;
    // const url = this.client.signatureUrl(val.serverFileName!, {response: {'content-disposition': 'attachment; filename=' + val.sourceFileName}});
    // window.location.href = url;
    this.service.signatureUrl(val.id!).then((response: any) => {
      window.location.href = response;
    });
  }


}
